"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isNil = _interopRequireDefault(require("../../../utils/object/isNil"));

var _Rectangle = _interopRequireDefault(require("../../../models/geometry/Rectangle"));

var _degreesToRadians = _interopRequireDefault(require("../../../utils/numbers/degreesToRadians"));

/**
 * Sets the transform on the canvas context
 *
 * @param {CanvasRenderingContext2D} context
 * @param {Number} translateX
 * @param {Number} translateY
 * @param {Number} scaleX
 * @param {Number} scaleY
 * @param {Number} rotation - rotation in degrees.
 * @param {Rectangle} canvasDimensions
 * @private
 */
var setContextTransform = function setContextTransform(context, translateX, translateY, scaleX, scaleY, rotation, canvasDimensions) {
  if ((0, _isNil["default"])(context)) {
    throw new Error('LayerRenderer._setContextTransform context is nil.');
  }

  if (!_Rectangle["default"].isValidRectangle(canvasDimensions)) {
    throw new Error('LayerRenderer._setContextTransform canvas dimensions are not valid');
  }

  var height = canvasDimensions.height,
      width = canvasDimensions.width;
  var angleInRadians = (0, _degreesToRadians["default"])(rotation);
  var sin = Math.sin(angleInRadians);
  var cos = Math.cos(angleInRadians);
  context.setTransform(cos * scaleX, sin * scaleX, -sin * scaleY, cos * scaleY, width / 2 + translateX, height / 2 + translateY);
};

var _default = setContextTransform;
exports["default"] = _default;